import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { ActivityLogPanel } from "@/components/activity-log";

const ActivityLogs = () => {
  // Note: fetched for potential filter usage; kept to avoid changing data-fetch behavior.
  const [, setActors] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    const fetchActors = async () => {
      const { data } = await supabase
        .from("app_users")
        .select("id, full_name")
        .order("full_name");

      if (data) {
        setActors(data.map((u) => ({ id: u.id, name: u.full_name })));
      }
    };

    fetchActors();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold mb-2">Activity Logs</h1>
        <p className="text-muted-foreground">
          Track all system changes and user actions across all entities
        </p>
      </div>

      <ActivityLogPanel
        title="All Activity"
        showFilters={true}
        showEntityBadge={true}
        maxHeight="calc(100vh - 280px)"
        limit={200}
      />
    </div>
  );
};

export default ActivityLogs;
